__turbopack_context__.v({
  "active": "gz2T4W_active",
  "categoryItem": "gz2T4W_categoryItem",
  "categoryNav": "gz2T4W_categoryNav",
  "clearFilters": "gz2T4W_clearFilters",
  "container": "gz2T4W_container",
  "detail": "gz2T4W_detail",
  "disabled": "gz2T4W_disabled",
  "filterBackdrop": "gz2T4W_filterBackdrop",
  "filterButtons": "gz2T4W_filterButtons",
  "filterControl": "gz2T4W_filterControl",
  "filterDrawerIn": "gz2T4W_filterDrawerIn",
  "filterGroup": "gz2T4W_filterGroup",
  "header": "gz2T4W_header",
  "heading": "gz2T4W_heading",
  "hoverActions": "gz2T4W_hoverActions",
  "imageContainer": "gz2T4W_imageContainer",
  "layout": "gz2T4W_layout",
  "mainContent": "gz2T4W_mainContent",
  "moreSimiler": "gz2T4W_moreSimiler",
  "newPrice": "gz2T4W_newPrice",
  "offerBadge": "gz2T4W_offerBadge",
  "oldPrice": "gz2T4W_oldPrice",
  "openSidebar": "gz2T4W_openSidebar",
  "pName": "gz2T4W_pName",
  "productCard": "gz2T4W_productCard",
  "productImage": "gz2T4W_productImage",
  "productInfo": "gz2T4W_productInfo",
  "productPrice": "gz2T4W_productPrice",
  "productsGrid": "gz2T4W_productsGrid",
  "quickAddButton": "gz2T4W_quickAddButton",
  "rating": "gz2T4W_rating",
  "reviewCount": "gz2T4W_reviewCount",
  "searchInput": "gz2T4W_searchInput",
  "series": "gz2T4W_series",
  "sidebar": "gz2T4W_sidebar",
  "sidebarClose": "gz2T4W_sidebarClose",
  "starFilled": "gz2T4W_starFilled",
  "starHalf": "gz2T4W_starHalf",
  "stars": "gz2T4W_stars",
  "toggleSidebar": "gz2T4W_toggleSidebar",
});
